enum RecommendationSource {
  OrderHistory = 'order-history',
  Prediction = 'prediction',
  FavoriteItem = 'favorite-item',
  Manual = 'manual',
  HeuristicsV2 = 'heuristics-v2',
  MenuItemAffinity = 'menu-item-affinity',
  MenuItemAffinityV2 = 'menu-item-affinity-v2',
  MenuItemAffinityBlended = 'menu-item-affinity-blended',
}

export { RecommendationSource };
